module.exports = __webpack_public_path__ + "static/golf-8317d30842c956dcc1cddd8d10326f9c.webm";